import * as IdEncoder from '@zillow/id-encoder';

// ported from the deprecated modules/analytics
// when this app's migration to serverless nextjs is complete, this will be obsolete
export const getServerSideEncodedGuidZuid = (guid: string, zuid: string): string => {
  /**
   * For example:
   * 23|%24b30d953b-ea95-4d1d-a0ba-3974870e37a9 =>
   * b30d953bea954d1da0ba3974870e37a9
   * Two versions of guids can be received, prefixed with 23 or 24.
   */
  const formattedGuid = guid.replace(/[2][3-4]\|%24|-/g, '');
  if (zuid === '') {
    // zuid only exists for logged in users, so for non logged in users, cd1 should the guid ONLY.
    return formattedGuid;
  }
  /**
   * For example:
   * 174717467 =>
   * X1-ZUtc3plkw6mtjd_1wtuu
   */
  const encodedZuid = IdEncoder.encodeZuidCode(zuid);

  return `${formattedGuid}/${encodedZuid}`;
};
